<div class="tag-item" title="{{ name }}" [style]="{ background: color }">
  <span>{{ name }}</span>
  @if (canRemove) {
    <i
      class="remove-tag feather x"
      tooltip="Remove"
      (click)="removeTag()"
    ></i>
  }
</div>
